/* Keep policy content intact while improving navigation and audited category-list presentation. */
(() => {
  // Only audited category sections qualify; unfamiliar and procedural lists keep numbering.
  const categorySections = {
    '/policies/privacy-policy': ['information we collect', 'how we use personal information', 'website platform, apps, and service providers', 'information sharing'],
    '/policies/refund-policy': ['general return window', 'lithium battery return restrictions', 'non-quality returns', 'product quality claims'],
    '/policies/shipping-policy': ['lithium battery shipping restrictions', 'failed delivery, refused shipment, and return to sender'],
    '/policies/subscription-policy': ['how to request cancellation'],
    '/policies/terms-of-service': ['customer responsibility for compatibility', 'orders and acceptance', 'prohibited uses'],
  };
  const normalizeCategoryLists = (body) => {
    const path = location.pathname.replace(/\/$/, '').match(/\/policies\/[^/]+$/)?.[0];
    const sections = categorySections[path];
    if (!sections) return;
    const normalize = (text) => text.trim().replace(/\s+/g, ' ').replace(/^\d+\s*[.)]\s*/, '').toLowerCase();
    const categoryLead = /\b(?:may include|including(?: but not limited to)?|responsible for|provide|contact us with|help us|affected by|must not|personal information (?:to|with)|following conditions)\s*:\s*$|\bfollowing products\b.*\bmay not qualify\b.*:\s*$|\bone or more of the following remedies\b.*:\s*$/i;
    const sequenceLead = /\b(?:steps?|step-by-step|procedure|sequence|sequential|in (?:this|the following) order)\b/i;
    let heading = '';
    body.querySelectorAll('h2, ol').forEach((node) => {
      if (node.tagName === 'H2') {
        heading = normalize(node.textContent);
        return;
      }
      if (!sections.includes(heading) || node.parentElement.closest('ol, ul')) return;
      if (['start', 'reversed', 'type'].some((attribute) => node.hasAttribute(attribute))) return;
      if (node.querySelector('li[value], ol, ul')) return;
      const lead = node.previousElementSibling?.textContent.trim().replace(/\s+/g, ' ') || '';
      if (!categoryLead.test(lead) || sequenceLead.test(lead)) return;
      const items = Array.from(node.children).filter((item) => item.tagName === 'LI');
      if (!items.length || items.some((item) => /^\s*(?:\d+[.)]\s|(?:first|second|third|next|then|finally)\b)/i.test(item.textContent))) return;
      const list = document.createElement('ul');
      Array.from(node.attributes).forEach((attribute) => list.setAttribute(attribute.name, attribute.value));
      list.classList.add('sentorise-policy-categories');
      while (node.firstChild) list.append(node.firstChild);
      node.replaceWith(list);
    });
  };
  const init = () => {
    const storeContainer = document.querySelector('body.template-policy #MainContent .shopify-policy__container');
    const appBody = document.querySelector('#MainContent .snt-legacy-content[data-snt-page="privacy-policy"]');
    const container = storeContainer || appBody?.parentElement;
    const body = storeContainer?.querySelector('.shopify-policy__body') || appBody;
    if (!body || !container) return;
    if (appBody) {
      container.classList.add('sentorise-app-policy-layout');
      appBody.querySelectorAll('table').forEach((table, index) => {
        if (table.parentElement.classList.contains('sentorise-app-policy-table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'sentorise-app-policy-table';
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('aria-label', `App privacy policy table ${index + 1}`);
        table.before(wrapper);
        wrapper.append(table);
        // Retain every word and cell; add header semantics to the existing first row.
        table.rows[0]?.querySelectorAll('td').forEach((cell) => {
          const header = document.createElement('th');
          Array.from(cell.attributes).forEach((attribute) => header.setAttribute(attribute.name, attribute.value));
          header.setAttribute('scope', 'col');
          while (cell.firstChild) header.append(cell.firstChild);
          cell.replaceWith(header);
        });
      });
    }
    normalizeCategoryLists(body);
    if (container.querySelector('.sentorise-policy-directory')) return;

    const headings = Array.from(body.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
    if (headings.length < 2) return;

    const script = document.querySelector('script[data-policy-navigation]');
    const label = script?.dataset.directoryLabel || 'On this page';
    const aside = document.createElement('aside');
    aside.className = 'sentorise-policy-directory';
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    summary.textContent = label;
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', label);
    const list = document.createElement('ul');
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = `sentorise-policy-section-${index + 1}`;
        let id = base;
        let suffix = 1;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim().replace(/\s+/g, ' ');
      item.append(link);
      list.append(item);
      link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!desktop.matches) details.open = false;
        history.replaceState(history.state, '', link.hash);
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    });
    nav.append(list);
    details.append(summary, nav);
    aside.append(details);
    container.insertBefore(aside, body);
    container.classList.add('has-policy-directory');

    const desktop = window.matchMedia('(min-width: 990px)');
    const syncLayout = () => {
      details.open = desktop.matches;
      if (desktop.matches) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    };
    summary.addEventListener('click', (event) => {
      if (desktop.matches) event.preventDefault();
    });
    desktop.addEventListener('change', syncLayout);
    syncLayout();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

